import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { MAX_TOTAL_BODY_CONTENTS_FOR_EDIT } from '@opengov/stories-shared/constants';
import React from 'react';

import { IEditorMessages } from '../../../../types';
import { styles } from './AddContent.styles';

export type IAddContentProps = {
  isReadOnlyMode: boolean;
  isLast: boolean;
  nextStoryContentOrder: number;
  messages: IEditorMessages;
  totalStoryContents: number;
  handleAddModal(nextModuleOrder: number): void;
};

export const AddContent: React.FC<IAddContentProps> = ({
  isReadOnlyMode,
  isLast,
  nextStoryContentOrder,
  messages,
  totalStoryContents,
  handleAddModal
}) => {
  if (isReadOnlyMode || isLast) {
    return null;
  }

  const disabled = totalStoryContents >= MAX_TOTAL_BODY_CONTENTS_FOR_EDIT;

  return (
    <Box sx={styles.container}>
      <Tooltip
        title={disabled ? messages.maxContentBlocksReached : messages.addContent}
        placement="bottom"
      >
        <Box component="span" sx={styles.buttonWrapper}>
          <IconButton
            size="small"
            disabled={disabled}
            data-test="story-content-add"
            aria-label={messages.addContent}
            onClick={() => handleAddModal(nextStoryContentOrder)}
            sx={styles.addButton}
          >
            <AddIcon fontSize="small" aria-hidden={true} />
          </IconButton>
        </Box>
      </Tooltip>
    </Box>
  );
};
